export default __webpack_public_path__ + "static/media/404.96442307.png";